import React, { useEffect, useState } from 'react';
import { getTripMeterPhoto } from '../services/api';

const OCR_META = {
  match: { label: 'Match', cls: 'ok' },
  mismatch: { label: 'Mismatch', cls: 'suspicious' },
  unreadable: { label: 'Unreadable', cls: 'pending' },
  pending: { label: 'Checking', cls: 'pending' },
  error: { label: 'Check failed', cls: 'pending' },
};

export function MeterCheckBadge({ trip }) {
  const meta = OCR_META[trip?.meterOcrStatus];
  if (!meta) return <span className="text-muted">—</span>;
  const reviewed = trip.meterOcrStatus === 'mismatch' && trip.meterOcrReviewed;
  return (
    <span className={`badge ${meta.cls}`} title={reviewed ? `Reviewed by ${trip.meterOcrReviewedBy || 'admin'}` : undefined}>
      {meta.label}{reviewed ? ' (reviewed)' : ''}
    </span>
  );
}

export default function MeterPhotoViewer({ trip, onClose }) {
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!trip?._id) return undefined;
    let objectUrl = '';
    let cancelled = false;
    setUrl('');
    setError('');
    getTripMeterPhoto(trip._id)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setError('Could not load the meter photo.');
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [trip?._id]);

  useEffect(() => {
    if (!trip) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [trip, onClose]);

  if (!trip) return null;

  const reading = trip.meterOcrReading;
  const diff = reading != null && trip.meterIn != null ? Number(trip.meterIn) - Number(reading) : null;

  return (
    <div className="meter-photo-overlay" onClick={onClose} role="presentation">
      <div className="meter-photo-dialog" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="meter-photo-header">
          <div>
            <div className="card-title" style={{ marginBottom: 2 }}>
              {trip.vehicle?.name || 'Vehicle'} — {trip.driver?.name || 'Driver'}
            </div>
            <div className="text-muted text-sm">Meter out {trip.meterOut ?? '—'}</div>
          </div>
          <button type="button" className="btn btn-sm" onClick={onClose}>Close</button>
        </div>

        <div className="meter-photo-body">
          {error ? (
            <p className="text-muted">{error}</p>
          ) : url ? (
            <img src={url} alt="Meter in" />
          ) : (
            <p className="text-muted">Loading photo…</p>
          )}
        </div>

        <div className="meter-photo-facts">
          <div>
            <div className="stat-label">Guard entered</div>
            <div className="mono">{trip.meterIn ?? '—'}</div>
          </div>
          <div>
            <div className="stat-label">Photo reading</div>
            <div className="mono">{reading ?? '—'}</div>
          </div>
          <div>
            <div className="stat-label">Meter check</div>
            <MeterCheckBadge trip={trip} />
          </div>
          {diff != null && diff !== 0 && (
            <div>
              <div className="stat-label">Difference</div>
              <div className="mono">{diff > 0 ? `+${diff}` : diff} km</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
